export const FETCH_MANUAL_HOT_LIST_TYPE = 'FETCH_MANUAL_HOT_LIST_TYPE';
export const FETCH_MANUAL_HOT_LIST_ERROR_TYPE = 'FETCH_MANUAL_HOT_LIST_ERROR_TYPE';
export const FETCH_VEHICLE_LIST_TYPE = 'FETCH_VEHICLE_LIST_TYPE';
export const ADD_MANUAL_HOT_LIST_TYPE = 'ADD_MANUAL_HOT_LIST_TYPE';
export const UPDATE_MANUAL_HOT_LIST_TYPE = 'UPDATE_MANUAL_HOT_LIST_TYPE';
export const REMOVE_MANUAL_HOT_LIST_TYPE = 'REMOVE_MANUAL_HOT_LIST';
export const CLEAR_VEHICLES = 'CLEAR_VEHICLES';
